import Controller from '@ember/controller';

export default class AuthenticatedProjectsShowProjectFilesIndexController extends Controller {}
